import { TypographyBase } from "@/components/typography/Base";
import {
  platformFeeRate,
  supplierFeeRate
} from "../../create-subscription-offer-form/utils/subscriptionFees";

interface Props {
  price?: number;
  trialDays?: number;
}

const PriceOutput = ({ price = 0, trialDays }: Props) => {
  const platformFeePercentage = platformFeeRate(price);
  const platformAmount = (price * platformFeePercentage) / 100;

  const receivedPercentage = supplierFeeRate(price);
  const receivedAmount = (price * receivedPercentage) / 100;

  return (
    <div className="w-full py-1 mt-4 border-t dark:border-brand-gray-600">
      <div className="grid grid-cols-[1fr_15ch_15ch] gap-4 items-center">
        <TypographyBase className="text-gray-600 dark:text-gray-400">
          Amount paid to your account:
        </TypographyBase>
        <TypographyBase
          className="text-gray-600 dark:text-gray-400 text-right"
          data-testid="received-percentage"
        >
          {receivedPercentage}%
        </TypographyBase>
        <TypographyBase
          className="text-gray-600 dark:text-gray-400 text-right"
          data-testid="received-amount"
        >
          ${receivedAmount.toFixed(2)}
        </TypographyBase>

        <TypographyBase className="text-gray-600 dark:text-gray-400">
          Numerous&apos;s fee:
        </TypographyBase>
        <TypographyBase
          className="text-gray-600 dark:text-gray-400 text-right"
          data-testid="platform-fee-percentage"
        >
          {platformFeePercentage}%
        </TypographyBase>
        <TypographyBase
          className="text-gray-600 dark:text-gray-400 text-right"
          data-testid="platform-fee-amount"
        >
          ${platformAmount.toFixed(2)}
        </TypographyBase>
      </div>

      <TypographyBase className="text-sm text-gray-600 dark:text-gray-400 mt-2">
        {trialDays
          ? `Monthly subscription fee. First installment will be charged ${trialDays} day${trialDays === 1 ? "" : "s"}
             after acceptance, if not cancelled in advance by the customer.`
          : "Monthly subscription fee. No trial period. The first installment will be charged immediately upon acceptance."}
      </TypographyBase>
    </div>
  );
};

export default PriceOutput;
